export const CHANGE_CLIENT = 'core/CHANGE_CLIENT';

export default client => {
    return {
        type: CHANGE_CLIENT,
        payload: client
    };
}
